import { render, staticRenderFns } from "./yw_categories.vue?vue&type=template&id=3a4e27ea&scoped=true&"
import script from "./yw_categories.vue?vue&type=script&lang=js&"
export * from "./yw_categories.vue?vue&type=script&lang=js&"
import style0 from "./yw_categories.vue?vue&type=style&index=0&id=3a4e27ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4e27ea",
  null
  
)

export default component.exports